import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import DashboardGridBox from '../DashboardGridBox.jsx';
import { toCommaNumber } from '../../../utils/format';

class LastLegRum extends DashboardGridBox {
    static propTypes = {
        selections: ImmutablePropTypes.list,
        status: PropTypes.string,

        getLastLegs: PropTypes.func.isRequired
    };

    constructor(props, context) {
        super(props, context);

        this.title = 'Last leg RUM selections';

        this.columns = [
            {
                name: 'name',
                label: 'Selection',
                width: 6
            },
            {
                name: 'stakes',
                label: 'Stakes',
                width: 2,
                class: 'widget-table__column-right'
            },
            {
                name: 'payout',
                label: 'Payout',
                width: 2,
                class: 'widget-table__column-right'
            },
            {
                name: 'sgls',
                label: 'Sgls P/L',
                width: 2,
                class: 'widget-table__column-right'
            }
        ];

        this.buildData(this.props);
    }

    UNSAFE_componentWillReceiveProps(props) {
        if ( this.props.selections !== props.selections ) {
            this.buildData(props);
        }

        // Start again the updates
        // when the customer is close/minimizez
        if ( props.stopTick !== this.props.stopTick ) {
            this.startTickUpdate(props);
        }
    }

    componentDidMount() {
        this.startTickUpdate(this.props);
    }

    startTickUpdate(props) {
        clearInterval(this.refresh);

        if ( props.stopTick ) {
            return;
        }

        props.getLastLegs();

        this.refresh = setInterval(() => {
            if (props.status === 'FINISHED') {
                props.getLastLegs();
            }
        }, 60000);
    }

    componentWillUnmount() {
        clearInterval(this.refresh);
    }

    onClickRedirect(data, route, event) {
        event.preventDefault();

        let { eventId, marketId } = data;

        let path = '';
        let params = {
            market: parseInt(marketId, 10)
        };

        if ( route === 'liabilities') {
            path = '/trading?tab=liabilities&liabilities=multiple&liabilities';
            params = {
                ...params,
                event: parseInt(eventId, 10)
            };
        } else if ( route === 'market' ) {
            path = `/trading?*events=${eventId}&*events`;
            params = {
                ...params,
                tab: 'markets',
                filter: 'open'
            };
        }


        window.open(path + '.parameters=' + JSON.stringify(params));
    }

    buildData(props) {
        let { selections } = props;

        this.data = selections.reduce( (out, selection) => {
            let price = selection.getIn([ 'selection', 'price' ]);
            let priceLabel = price ? ` (${price.get('priceNum')}/${price.get('priceDen')})` : '';

            return out.concat([
                {
                    key: selection.getIn([ 'selection', 'id' ]) + selection.getIn([ 'market', 'id' ]),
                    eventId: parseInt(selection.getIn([ 'event', 'id' ]), 10),
                    marketId: parseInt(selection.getIn([ 'market', 'id' ]), 10),

                    payout: selection.get('payout') / 100,
                    profitLoss: selection.get('profitLoss') / 100,
                    stakes: selection.get('stakes') / 100,

                    name: selection.getIn([ 'selection', 'name' ]) + `${priceLabel}`,
                    event: selection.getIn([ 'event', 'name' ]) + ' - ' + selection.getIn([ 'market', 'name' ])
                }
            ]);
        }, []).sort( (prev, next) => prev.payout - next.payout );
    }

    renderTable() {
        const legRumHeader = (
            <div className="widget-table__header" key="leg-rum-header">
                <div className="row">
                    {
                        this.columns.map(col => (
                            <div className={`col-${col.width} ${col.class}`} key={col.name}>{ col.label }</div>
                        ))
                    }
                </div>
            </div>
        );

        const legRumRows = this.data.map(item => {
            const style = Math.sign(item.profitLoss) ? { color: 'red' } : null;

            return (
                <div className={`widget-table__row`} key={ item.key }>
                    <div className="row">
                        <div className="col-6">
                            <a href="" onClick={this.onClickRedirect.bind(this, item, 'market')}>
                                <strong>{ item.name }</strong>
                            </a>
                        </div>

                        <div className="col-2 widget-table__column-right">
                            { toCommaNumber(item.stakes) }
                        </div>

                        <div className="col-2 widget-table__column-right">
                            { toCommaNumber(parseInt(item.payout, 10)) }
                        </div>

                        <div className="col-2 widget-table__column-right">
                            <a href="" onClick={this.onClickRedirect.bind(this, item, 'liabilities')} style={style}>
                                { toCommaNumber(parseInt(item.profitLoss, 10)) }
                            </a>
                        </div>

                        <div className="col-12 widget-table__text-small">
                            { item.event }
                        </div>
                    </div>
                </div>
            );
        });

        return [ legRumHeader, ...legRumRows ];
    }

    renderElement() {
        const { status } = this.props;
        const count = this.data.length;

        let spinner = null;
        if ( status === 'IN_PROGRESS' && count === 0 ) {
            spinner = <div className="spinner spinner--inline"> </div>;
        }

        const message = status === 'FINISHED' && count === 0 ? (
            <div className="widget-table__not-found">
                No leg rums
            </div>
        ) : null;

        return (
            <div className="last-leg-rum widget-table">
                { message }
                { spinner }
                { count ? this.renderTable() : null }
            </div>
        );
    }
}

LastLegRum.WIDTH = 4;
LastLegRum.HEIGHT = 8;
LastLegRum.X = 4;
LastLegRum.Y = 0;

export default LastLegRum;
